export default "__VITE_ASSET__CtWRTIk2__"